module.exports = "https://r.nearpod.com/assets/media/image/ms-icon-644572ca7f4755474ca2a2ba3f780604.svg";